// Dollar format directive
export default {
  // Called before the bound element's parent component is mounted
  beforeMount: (el, binding) => {
    updateElement(el, binding);
  },
  // Called when the bound element's parent component is updated
  updated: (el, binding) => {
    updateElement(el, binding);
  }
};

// Helper function to update the element's content
function updateElement(el, binding) {
  const value = binding.value || 0;
  
  // Format number as US Dollar
  let formattedValue = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(value);
  
  el.textContent = formattedValue;
} 